import "../styles/Navbar.css";
import logo from "../assets/logo.png";
import { NavLink, Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  FaWhatsapp,
  FaPhoneAlt,
  FaFacebookF,
  FaEnvelope,
  FaInstagram,
  FaTiktok,
  FaGlobe,
} from "react-icons/fa";

function Navbar() {
  const { t, i18n } = useTranslation();

console.log("Current language:", i18n.language);
console.log("Resolved language:", i18n.resolvedLanguage);
console.log("Hero title:", t("hero_title"));
console.log("EN resource:", i18n.getResource("en", "translation", "hero_title"));
console.log("AR resource:", i18n.getResource("ar", "translation", "hero_title"));
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);
  const dropdownRef = useRef(null);

  // Contact links
  const whatsappLink = "https://wa.me/201205585860";
  const callLink = "tel:+201205585860";
  const facebookLink = "https://www.facebook.com/share/1CkKahyXtT/";
  const instagramLink =
    "https://www.instagram.com/egyptian_international_?utm_source=qr";
  const tiktokLink =
    "https://www.tiktok.com/@egyption_international?_r=1&_t=ZS-97aWp97XzXO";
  const emailLink =
    "mailto:salesegyptianinternational@gmail.com";

  // Outside click closes dropdown
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ESC closes dropdown
  useEffect(() => {
    function handleEsc(e) {
      if (e.key === "Escape") {
        setOpen(false);
      }
    }

    document.addEventListener("keydown", handleEsc);

    return () =>
      document.removeEventListener("keydown", handleEsc);
  }, []);

  // Hide navbar while scrolling down
  useEffect(() => {
    function handleScroll() {
      const currentY = window.scrollY;

      if (currentY > lastScrollY.current && currentY > 80) {
        setVisible(false);
      } else {
        setVisible(true);
      }

      lastScrollY.current = currentY;
    }

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, []);

  // toggles between ar and en
  function toggleLanguage() {
    const next = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(next);
  }

  return (
    <header className={`navbar ${visible ? "show" : "hide"}`}>
      <div className="navbar-glow"></div>

      <div className="navbar-container">

        {/* LOGO */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        {/* NAV LINKS */}
        <nav className="nav-links">
          <NavLink to="/" className="nav-item">
            {t("nav_home")}
          </NavLink>

          <NavLink to="/about" className="nav-item">
            {t("nav_about")}
          </NavLink>

          <NavLink to="/products" className="nav-item">
            {t("nav_products")}
          </NavLink>

          <NavLink to="/contact" className="nav-item">
            {t("nav_contact")}
          </NavLink>
        </nav>

        {/* CONTACT DROPDOWN */}
        <div
          className="nav-global-dropdown"
          ref={dropdownRef}
        >
          <button
            className="global-btn"
            onClick={() => setOpen((prev) => !prev)}
          >
            {t("contact_dropdown_toggle")}
          </button>

          <div className={`global-menu ${open ? "show" : ""}`}>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
            >
              <FaWhatsapp className="menu-icon" />
              {t("contact_whatsapp")}
            </a>

            <a href={callLink}>
              <FaPhoneAlt className="menu-icon" />
              {t("contact_call")}
            </a>

            <a
              href={facebookLink}
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF className="menu-icon" />
              {t("contact_facebook")}
            </a>

            <a
              href={instagramLink}
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram className="menu-icon" />
              {t("contact_instagram")}
            </a>

            <a
              href={tiktokLink}
              target="_blank"
              rel="noreferrer"
            >
              <FaTiktok className="menu-icon" />
              {t("contact_tiktok")}
            </a>

            <a href={emailLink}>
              <FaEnvelope className="menu-icon" />
              {t("contact_email")}
            </a>

          </div>
        </div>

        {/* LANGUAGE SWITCHER */}
        <button className="lang-switch-btn" onClick={toggleLanguage}>
          <FaGlobe className="menu-icon" />
          {i18n.language === "ar" ? "English" : "العربية"}
        </button>

      </div>
    </header>
  );
}

export default Navbar;
